/**
 * The mutation key of the Appearance card's save (PUT /api/me/settings with the theme).
 *
 * ThemeServerSync looks for a save under this key before it takes the signed-in user's saved theme. A
 * save still on its way (running, or queued behind another in the card's mutation scope) is newer than
 * anything /auth/me could have read, so while one is, the choice on screen stays.
 */
export const THEME_SAVE_KEY = ['theme-preference'] as const;
